import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['../../../authentication/components/authentication/authentication.component.scss'] 
})
export class SuccessComponent implements OnInit, OnDestroy {
  message: string;
  countdown: number = 5;
  private countdownInterval: any;

  constructor(private router: Router) { 
    const navigation = this.router.getCurrentNavigation();
    console.log("msg " + navigation?.extras?.state);
    this.message = navigation?.extras?.state!['message'] || 'Registration Successful';
  }

  ngOnInit(): void { 
    // Start countdown
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  redirectNow(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
  }
}
